import { HTTPClient } from '../utils/request'

export default {
  get: ({ query }) => HTTPClient.get(`/offers${query}`),
  store: ({ payload }) => HTTPClient.post(`/offers`, payload),
  count: ({ query }) => HTTPClient.get(`/offers/count${query}`),
  uninterest: ({ params, payload }) =>
    HTTPClient.post(`/offers/${params._id}/uninterested`, payload),
  attach: ({ params, payload, query = `` }) =>
    HTTPClient.post(`/offers/${params._id}/attach${query}`, payload),
  loaded: ({ params, payload }) =>
    HTTPClient.post(`/offers/${params._id}/loaded`, payload),
  cancel: ({ params }) => HTTPClient.post(`/offers/${params._id}/cancel`),
  deliver: ({ params, payload }) =>
    HTTPClient.post(`/offers/${params._id}/delivered`, payload),
  reject: ({ params }) =>
    HTTPClient.post(`/offers/${params._id}/delivered/reject`),
  finish: ({ params }) => HTTPClient.post(`/offers/${params._id}/done`),
  remove: ({ params }) => HTTPClient.delete(`/offers/${params._id}`),
  share: ({ payload }) => HTTPClient.post(`/shared`, payload),
  negotiate: ({ params, payload }) =>
    HTTPClient.post(`/offers/${params._id}/negotiation`, payload),
  replicate: ({ params, payload }) =>
    HTTPClient.post(`/offers/replicate/${params._id}`, payload),
  csv: ({ payload }) => HTTPClient.post(`/offers/importCsv`, payload),
  sm: ({ payload }) => HTTPClient.post(`/sm`, payload),
  download: ({ payload }) => HTTPClient.post(`/download`, payload),
  smDownloaded: ({ params }) => HTTPClient.post(`/sm/check/${params._id}`),
  sendNFE: ({ params, payload}) => HTTPClient.post(`/offers/nfe/${params._id}`,payload),
  setDelivered: ({ params, payload }) => HTTPClient.post(`/offers/delivered/${params._id}`, payload),

}
